'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _Locale = require('../../Locale');

var _Locale2 = _interopRequireDefault(_Locale);

var _Pager = require('./Pager.scss');

var _Pager2 = _interopRequireDefault(_Pager);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _ButtonLight = require('../../managewidgets/components/button/ButtonLight');

var _ButtonLight2 = _interopRequireDefault(_ButtonLight);

var _Label = require('../../managewidgets/components/label/Label');

var _Label2 = _interopRequireDefault(_Label);

var _IconPath = require('../../services/IconPath');

var _IconPath2 = _interopRequireDefault(_IconPath);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Pager = function Pager(props) {
  var formatMessage = props.intl.formatMessage;


  if (!props.totalPages || props.totalPages < 2) {
    return null;
  }

  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)(props.className, _Pager2.default.wrap) },
    _react2.default.createElement(_ButtonLight2.default, {
      automationName: 'pagerPrev',
      className: _Pager2.default.btn,
      icon: _IconPath2.default.get('Action_Back'),
      onClick: function onClick() {
        props.onPageChangeClick(props.currentPage - 1);
      },
      disabled: props.currentPage === 1 }),
    _react2.default.createElement(_Label2.default, {
      className: _Pager2.default.label,
      value: formatMessage(_Locale2.default.pager, { currentPage: props.currentPage, totalPages: props.totalPages }) }),
    _react2.default.createElement(_ButtonLight2.default, {
      automationName: 'pagerNext',
      className: _Pager2.default.btn,
      icon: _IconPath2.default.get('Action_Forward'),
      onClick: function onClick() {
        props.onPageChangeClick(props.currentPage + 1);
      },
      disabled: props.currentPage === props.totalPages })
  );
};

exports.default = (0, _reactIntl.injectIntl)(Pager);


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/components/pager/Pager.js
// module id = 343
// module chunks = 10